import { render, staticRenderFns } from "./ShowCustomer.vue?vue&type=template&id=a9ff57fc&scoped=true"
import script from "./ShowCustomer.vue?vue&type=script&lang=js"
export * from "./ShowCustomer.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomer.vue?vue&type=style&index=0&id=a9ff57fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ff57fc",
  null
  
)

export default component.exports